import React, { Component, Fragment  } from 'react';
import { Menu } from 'semantic-ui-react';


class LoginRecordsMenu extends Component {
    state = {
        selectedSubMenu: 'loginrecords'
    }

    render() {
        const { selectedSubMenu } = this.state;

        return (
            <Fragment>
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                    <Menu.Item key='loginrecords' name="loginrecords" active={selectedSubMenu === 'loginrecords'}>
                        Login Records
                    </Menu.Item>
                </Menu>
            </Fragment>
        )
    }
}

export default LoginRecordsMenu;